import React from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";

import "./NoteCard.css";
import EditProject from "./editProject";

export default function NoteCard({ projects, handleDelete, handleEdit, id }) {
  const [open, setOpen] = React.useState(false);
  const [project, setProject] = React.useState(null);
  return (
    <div>
      <Card elevation={1}>
        <CardHeader
          action={
            <>
              <IconButton
                onClick={() => {
                  setOpen(!open);
                  setProject(projects);
                }}
              >
                <EditIcon />
              </IconButton>

              <EditProject open={open} setOpen={setOpen} project={project} />

              <IconButton
                onClick={() => {
                  // console.log(projects._id);
                  handleDelete(id);
                }}
              >
                <DeleteOutlineIcon />
              </IconButton>
            </>
          }
          title={projects.name}
          subheader={projects.live}
        />
        <CardMedia
          component="img"
          height="194"
          image={projects.project_image}
          alt="image"
        />
        <CardContent>
          <p className="project__description">{projects.description}</p>
        </CardContent>
      </Card>
    </div>
  );
}
